import PartnershipModelAndAddOn from './PartnershipModelAndAddOn.vue';

export default PartnershipModelAndAddOn;
